// Import 3rd-party  dependencies
import { Directive, HostListener, Input } from '@angular/core';

// Import project-specific dependencies
import { InsightsService } from '@app/core/analytics/services/app-insights-service';

interface TrackData {
  link: string;
  title: string;
}

@Directive({ selector: '[appInsightsTrack]' })
export class TrackingDirective {
  @Input('eventData') data: TrackData; // eslint-disable-line @angular-eslint/no-input-rename
  @Input() action: string;
  @Input() loc: string;

  constructor(private track: InsightsService) {}

  @HostListener('click', ['$event'])
  click(): void {
    this.track.trackClickEvent({
      link: this.data.link,
      name: this.action ? this.action.concat(` ${this.data.title}`) : this.data.title,
      title: this.data.title,
      location: this.loc
    });
  }
}
